// src/services/fetchHelper.js

import { getCommonHeadersData, getInitData } from "./commonHeaders";
import { feLog } from "../utils/frontendLogger";

/**
 * Universal fetch wrapper that adds common headers.
 * @param {string} url - API endpoint
 * @param {Object} options - request options (method, body, etc.)
 * @param {string} [options.token] - JWT token if needed
 * @param {Object} [options.extraHeaders] - additional headers
 * @returns {Promise<Response>} - Response object
 */
export async function fetchWithCommonHeaders(url, options = {}) {
    const {
        token,
        method = "GET",
        body,
        extraHeaders = {}
    } = options;

    // Получаем общие данные для заголовков
    const { userAgent, platform, version, visitorId } = await getCommonHeadersData();

    // Формируем заголовки
    const headers = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "X-User-Agent": userAgent,
        "X-Telegram-Platform": platform,
        "X-Telegram-Version": version,
        "X-Visitor-Id": visitorId,
        ...extraHeaders,
    };

    const fetchOptions = {
        method,
        headers,
        credentials: "include", // если нужно
    };

    // ==== ВАЖНАЯ ЧАСТЬ: если POST, добавляем initData ====
    let finalBody = body || {};
    if (method.toUpperCase() === "POST") {
        const initData = getInitData();
        // Если у нас есть initData, добавляем его в тело
        if (initData) {
            finalBody = {
                ...finalBody,
                initData, // новое поле
            };
        }
    }

    // Если в finalBody что-то есть — сериализуем
    if (Object.keys(finalBody).length > 0) {
        fetchOptions.body = JSON.stringify(finalBody);
    }

    try {
        return await fetch(url, fetchOptions);
    } catch (error) {
        // Network error (server unreachable, no internet, etc.)
        feLog('error', 'api.network_error', String(error), { url: url.split('?')[0] });
        // Create a fake Response object that indicates failure
        // Status must be in range 200-599, we use 503 (Service Unavailable)
        return new Response(JSON.stringify({ error: 'Network error', message: error.message }), {
            status: 503,
            statusText: 'Service Unavailable',
            headers: new Headers({ 'Content-Type': 'application/json' })
        });
    }
}